import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for select style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiSwitchStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      width: 36,
      height: 20,
      padding: 0,
      marginRight: 14,
    },
    thumb: {
      height: 16,
      width: 16,
      boxShadow: theme.shadows[0],
    },
    track: {
      borderRadius: 100,
      opacity: 1,
      backgroundColor: theme.palette.grey['200'],
    },
    switchBase: {
      padding: 2,

      '&$checked': {
        transform: 'translateX(16px)',
      },
      '&$checked + $track': {
        opacity: 1,
      },

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    colorPrimary: {
      '&$checked': {
        color: theme.palette.common.white,
      },
    },
    checked: {},
  };
};
